import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Subscription, merge } from 'rxjs';
import {
  CollectionManagerType,
  DownloadManagerService,
  FileManagerType,
  UploadCollectionController,
  collectionRemovedObserver,
  collectionUploadListChange,
  downloadFinishedObserver,
  downloadPausedObserver,
  downloadResumedObserver,
  downloadStartedObserver,
  fileRemovedObserver,
} from 'src/app/shared/services/download-manager-service';
import { ServerRestApiService } from 'src/app/shared/services/server-rest-api.service';
import { sideMenuActiveObserver } from 'src/app/shared/shared-observers';

@Component({
  selector: 'app-download-manager',
  templateUrl: './download-manager.component.html',
  styleUrls: ['./download-manager.component.scss'],
})
export class DownloadManagerComponent implements OnInit, OnDestroy {
  fileList: FileManagerType[] = [];
  collectionList: CollectionManagerType[] = [];

  partialProgress: number = 0;
  showPartialProgress: boolean = false;
  isConnectionError: boolean = false;

  public canResumeDownload: boolean = true;

  private downloadObserversSub: Subscription;

  public collectionUploadList: UploadCollectionController[] = [];

  constructor(
    protected downloadManagerService: DownloadManagerService,
    private serverRestApiService: ServerRestApiService,
    private bottomSheetRef: MatBottomSheetRef<DownloadManagerComponent>
  ) {
    this.fileList = this.downloadManagerService.getFileList();
    this.collectionList = this.downloadManagerService.getCollectionList();
  }
  ngOnDestroy(): void {
    this.downloadObserversSub.unsubscribe();
    this.serverRestApiService.unsubscribeOnWSDisconnected(this.onWSDisconnect);
    this.serverRestApiService.unsubscribeOnWSConnected(this.onWSConnect);
    this.collectionUploadListChangeSubscription.unsubscribe();
  }

  ngOnInit(): void {
    sideMenuActiveObserver.next(false);

    merge(collectionRemovedObserver, fileRemovedObserver).subscribe(() => {
      if (this.fileList.length === 0 && this.collectionList.length === 0)
        this.bottomSheetRef.dismiss();
    });

    this.canResumeDownload = this.downloadManagerService.canCreateDownloadTask();

    this.downloadObserversSub = merge(
      downloadStartedObserver,
      downloadFinishedObserver,
      downloadPausedObserver,
      downloadResumedObserver
    ).subscribe(() => {
      this.canResumeDownload = this.downloadManagerService.canCreateDownloadTask();
    });

    this.serverRestApiService.subscribeOnWSDisconnected(this.onWSDisconnect);
    this.serverRestApiService.subscribeOnWSConnected(this.onWSConnect);

    this.collectionUploadList = Object.values(
      this.downloadManagerService.getAllCollectionUploads()
    );
    this.collectionUploadListChangeSubscription = collectionUploadListChange.subscribe((list) => {
      this.collectionUploadList = Object.values(list);
    });
  }

  private collectionUploadListChangeSubscription: Subscription;

  onWSDisconnect = () => {
    this.isConnectionError = true;
  };

  onWSConnect = () => {
    this.isConnectionError = false;
  };

  public removeReady(): void {
    this.downloadManagerService.removeFinishedFromFileList();
  }
}
